import { render, staticRenderFns } from "./semester.vue?vue&type=template&id=3338ae3f"
import script from "./semester.vue?vue&type=script&lang=js"
export * from "./semester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports